import { render } from "./GoddesPage.vue?vue&type=template&id=701fdb93&scoped=true"
const script = {}

import "./GoddesPage.vue?vue&type=style&index=0&id=701fdb93&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-701fdb93"]])

export default __exports__